var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardHeader',{attrs:{"title":"Print Payslips"}},[_c('iframe',{attrs:{"src":_vm.pdf,"width":"100%","height":"900"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }